import React, { FC, ReactNode, useCallback, useMemo } from 'react'
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react'
import { WalletAdapterNetwork, WalletError } from '@solana/wallet-adapter-base'
import {
  // LedgerWalletAdapter,
  PhantomWalletAdapter,
  SlopeWalletAdapter,
  SolflareWalletAdapter,
  // SolletExtensionWalletAdapter,
  // SolletWalletAdapter,
  BackpackWalletAdapter,
  TorusWalletAdapter,
  GlowWalletAdapter,
  CoinbaseWalletAdapter,
} from '@solana/wallet-adapter-wallets'
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui'
import { useToasts } from '@geist-ui/react'
// import {
//   createDefaultAuthorizationResultCache,
//   SolanaMobileWalletAdapter,
// } from '@solana-mobile/wallet-adapter-mobile'
import { CrossmintEnvironment, CrossmintSolanaWalletAdapter } from '@crossmint/connect'

// Default styles that can be overridden by your app
require('@solana/wallet-adapter-react-ui/styles.css')

type Props = {
  children?: ReactNode
}

export const Wallet: FC = ({ children }: Props) => {
  // The network can be set to 'devnet', 'testnet', or 'mainnet-beta'.
  const network =
    process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
      ? 'https://withered-convincing-water.solana-mainnet.quiknode.pro/76f7977f2094f06f1ec57ce30a954e260b828963/'
      : 'https://api.devnet.solana.com'

  // You can also provide a custom RPC endpoint.
  const endpoint = useMemo(() => network, [network])

  // const endpoint = 'http://127.0.0.1:8899'
  // const network = undefined

  // @solana/wallet-adapter-wallets includes all the adapters but supports tree shaking and lazy loading --
  // Only the wallets you configure here will be compiled into your application, and only the dependencies
  // of wallets that your users connect to will be loaded.
  const wallets = useMemo(
    () => [
      // new SolanaMobileWalletAdapter({
      //   appIdentity: { name: 'Glass' },
      //   authorizationResultCache: createDefaultAuthorizationResultCache(),
      // }),
      new CrossmintSolanaWalletAdapter({
        apiKey: 'maxwell-test',
        forceInstalled: true,
        environment:
          process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
            ? CrossmintEnvironment.PROD
            : CrossmintEnvironment.STAGING,
        maxTimeAutoConnectMs: 500,
      }),
      new PhantomWalletAdapter(),
      new CoinbaseWalletAdapter(),
      new GlowWalletAdapter(),
      new SlopeWalletAdapter(),
      new SolflareWalletAdapter({
        network:
          process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
            ? WalletAdapterNetwork.Mainnet
            : WalletAdapterNetwork.Devnet,
      }),
      new TorusWalletAdapter(),
      new BackpackWalletAdapter(),
      // new LedgerWalletAdapter(),
      // new SolletWalletAdapter({ network }),
      // new SolletExtensionWalletAdapter({ network }),
    ],
    []
  )

  const [, setToast] = useToasts()
  const onError = useCallback(
    (error: WalletError) => {
      setToast({
        text: error.message ? `${error.name}: ${error.message}` : error.name,
        type: 'error',
      })
      console.error(error)
    },
    [setToast]
  )

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} onError={onError} autoConnect>
        <WalletModalProvider>{children}</WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  )
}
